module.exports = __webpack_public_path__ + "static/media/iconCards.387dc38b.png";